module.exports = __webpack_public_path__ + "img/3_h_no.1c358a4d.svg";